module.exports = __webpack_public_path__ + "a0badb8702f264139d38d9b18b9bf453.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/s3-config.png
// module id = 272
// module chunks = 1